
const stateAbbreviation = [
    {
        name: "Alaska",
        abbreviation: "AK"
    },
    {
        name: "Alabama",
        abbreviation: "AL"
    },
    {
        name: "Arkansas",
        abbreviation: "AR"
    },
    {
        name: "American Samoa",
        abbreviation: "AS"
    },
    {
        name: "Arizona",
        abbreviation: "AZ"
    },
    {
        name: "California",
        abbreviation: "CA"
    },
    {
        name: "Colorado",
        abbreviation: "CO"
    },
    {
        name: "Connecticut",
        abbreviation: "CT"
    },
    {
        name: "District Of Columbia",
        abbreviation: "DC"
    },
    {
        name: "Delaware",
        abbreviation: "DE"
    },
    {
        name: "Florida",
        abbreviation: "FL"
    },
    {
        name: "Georgia",
        abbreviation: "GA"
    },
    {
        name: "Guam",
        abbreviation: "GU"
    },
    {
        name: "Hawaii",
        abbreviation: "HI"
    },
    {
        name: "Iowa",
        abbreviation: "IA"
    },
    {
        name: "Idaho",
        abbreviation: "ID"
    },
    {
        name: "Illinois",
        abbreviation: "IL"
    },
    {
        name: "Indiana",
        abbreviation: "IN"
    },
    {
        name: "Kansas",
        abbreviation: "KS"
    },
    {
        name: "Kentucky",
        abbreviation: "KY"
    },
    {
        name: "Louisiana",
        abbreviation: "LA"
    },
    {
        name: "Massachusetts",
        abbreviation: "MA"
    },
    {
        name: "Maryland",
        abbreviation: "MD"
    },
    {
        name: "Maine",
        abbreviation: "ME"
    },
    {
        name: "Michigan",
        abbreviation: "MI"
    },
    {
        name: "Minnesota",
        abbreviation: "MN"
    },
    {
        name: "Missouri",
        abbreviation: "MO"
    },
    {
        name: "Northern Mariana Islands",
        abbreviation: "MP"
    },
    {
        name: "Mississippi",
        abbreviation: "MS"
    },
    {
        name: "Montana",
        abbreviation: "MT"
    },
    {
        name: "North Carolina",
        abbreviation: "NC"
    },
    {
        name: "North Dakota",
        abbreviation: "ND"
    },
    {
        name: "Nebraska",
        abbreviation: "NE"
    },
    {
        name: "New Hampshire",
        abbreviation: "NH"
    },
    {
        name: "New Jersey",
        abbreviation: "NJ"
    },
    {
        name: "New Mexico",
        abbreviation: "NM"
    },
    {
        name: "Nevada",
        abbreviation: "NV"
    },
    {
        name: "New York",
        abbreviation: "NY"
    },
    {
        name: "Ohio",
        abbreviation: "OH"
    },
    {
        name: "Oklahoma",
        abbreviation: "OK"
    },
    {
        name: "Oregon",
        abbreviation: "OR"
    },
    {
        name: "Pennsylvania",
        abbreviation: "PA"
    },
    {
        name: "Puerto Rico",
        abbreviation: "PR"
    },
    {
        name: "Rhode Island",
        abbreviation: "RI"
    },
    {
        name: "South Carolina",
        abbreviation: "SC"
    },
    {
        name: "South Dakota",
        abbreviation: "SD"
    },
    {
        name: "Tennessee",
        abbreviation: "TN"
    },
    {
        name: "Texas",
        abbreviation: "TX"
    },
    {
        name: "Utah",
        abbreviation: "UT"
    },
    {
        name: "Virginia",
        abbreviation: "VA"
    },
    {
        name: "Virgin Islands",
        abbreviation: "VI"
    },
    {
        name: "Vermont",
        abbreviation: "VT"
    },
    {
        name: "Washington",
        abbreviation: "WA"
    },
    {
        name: "Wisconsin",
        abbreviation: "WI"
    },
    {
        name: "West Virginia",
        abbreviation: "WV"
    },
    {
        name: "Wyoming",
        abbreviation: "WY"
    }
]

export default stateAbbreviation